var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.763672,
    height: 24.800293,
    viewBox: "0 0 24.7637 24.8003",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 65",
    d: "M23.21 11.62C23.95 11.99 23.94 13.04 23.2 13.41L2.44 23.67C1.77 24 1 23.52 1 22.78L1 15.22C1 14.71 1.38 14.28 1.9 14.23L9.26 13.5C10.46 13.38 10.46 11.63 9.27 11.51L1.89 10.74C1.38 10.68 1 10.25 1 9.74L1 2.01C1 1.27 1.78 0.78 2.45 1.12L23.21 11.62Z",
    stroke: "#50964E",
    strokeOpacity: 1,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic_send.b0a5c270d0ecc5f6d7673fb8a95d43d4.svg";
export { ForwardRef as ReactComponent };